export type modifyConsumptionParams = {
  cups: string
  previousAnnualConsumption: number
  newConsumptions: []
  reason: string
}

export type ApiErrors = {
  404: string
  400: string
  500: string
}

export const API_ERRORS_MESSAGE = {
  404: 'modify-consumption-not-found',
  400: 'modify-consumption-param-request-wrong',
  422: 'modify-consumption-param-request-wrong',
  500: 'api-error',
}
